import React, { useState, useEffect } from 'react';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
    const BaseURL = process.env.REACT_APP_API;
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChangePassword = async () => {
        if (!email) {
             return NotificationManager.warning("Please enter your email address.");
        }

        if (!newPassword || !confirmPassword) {
            return NotificationManager.warning("Please enter password.");
        }
        if (newPassword !== confirmPassword) {
            NotificationManager.warning("New and confirm passwords do not match.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${BaseURL}/api/admin/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    currentPassword,
                    newPassword,
                }),
            });

            const result = await response.json();

            if (response.ok) {
                NotificationManager.success('Password changed successfully!');
                // Optionally clear form
                setEmail('');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                NotificationManager.error(result?.error || 'Failed to change password.');
            }
        } catch (error) {
            NotificationManager.error('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

        // Check authentication on component mount
      useEffect(() => {
        const token = sessionStorage.getItem('AdminAuthToken');
        if (!token) {
          navigate('/');
        }
      }, [navigate]);

    return (
        <div className="py-24 px-24 d-flex flex-column justify-content-center">
            <div className="max-w-464-px mx-auto w-100">
                <h5 className="mb-12">Change Password</h5>

                <div className="d-flex flex-column gap-3">
                    <input
                        type="email"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>

                <button
                    type="button"
                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                    onClick={handleChangePassword}
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Continue'}
                </button>
            </div>
        </div>
    );
};

export default ChangePassword;
